export default __webpack_public_path__ + "static/img01-9277c741e3f24da9bc9a2cb872a6e084.svg";